import React, { useCallback, useState, useMemo, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import PaymentSource from '../../../external-components/payments/steps/PaymentSource';
import { Icon, Button, Modal, Form, Dimmer, Loader, Message } from 'semantic-ui-react';

const AddWalletModal = ({ open, onOpen, onClose, payment, actions, onAdd, userEmailAddress, userId }) => {
	const [source, setSource] = useState({});
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);

	const [data, setData] = useState({
		nickname: ''
	});

	const customSettings = useMemo(() => {
		return payment && payment.settings ? { ...payment.settings, allowUseOfWalletItems: false } : null;
	}, [payment]);

	const ref = useRef();

	const [isValid, setIsValid] = useState(false);

	const _onAdd = useCallback(async (_source) => {
		// set default nickname
		if (!data.nickname) {
			if (_source.accountNumber) {
                data.nickname = _source.accountNumber.slice(_source.accountNumber.length - 4, _source.accountNumber.length);
            } else {
                data.nickname = _source.fiserv.fundingAccountLastFourDigit;
            }
        }

        setSource(_source);
		setLoading(true);
		try {
			setError(null);
			await actions.addPaymentWallet({ ...data, ..._source, bankAccountType: _source.type });
			setLoading(false);
			if (onAdd) onAdd();
		} catch(err) {
			setLoading(false);
			setError(err);
		}
	}, [actions, data, onAdd]);

	const _onOpen = useCallback(() => {
		if (ref.current) ref.current.reset();
		setError(null)
		setSource({})
		if (onOpen) onOpen();
	}, [onOpen]);

	const onChange = useCallback(
		(name, value) => {
			setError(null)
			setData({ ...data, [name]: value });
		},
		[data]
	);

	useEffect(() => {
		if (!ref.current) {
			setIsValid(false);
            return;
        }
		const _isValid = data.emailAddress !== '' && ref.current.isValid();
		setIsValid(_isValid);
	}, [data, source]);

	const onAddButtonClick = useCallback(() => {
        ref.current.add();
    }, [])

	return (
		<Modal
			open={open}
			onOpen={_onOpen}
			onClose={onClose}
			trigger={
				<span style={{ cursor: 'pointer' }}>
					<Icon name='add' />
					Add Wallet Item
				</span>
			}>
			<Modal.Header>Add Wallet Item</Modal.Header>
			<Modal.Content>
				{loading && (
					<Dimmer active inverted>
						<Loader active size='massive'>
							Submitting Wallet Information...
						</Loader>
					</Dimmer>
				)}
				{error && 
					<Message error>
					Error saving Wallet information: {error.error}
					</Message>}
				<Form>
					<Form.Input label='Nickname' value={data.nickname} onChange={(_, { value }) => onChange('nickname', value)} />
					<PaymentSource ref={ref} source={source} {...payment} settings={customSettings} actions={actions} onSourceUpdate={setSource} onSourceAdd={_onAdd} onIsValidUpdate={setIsValid} userEmailAddress={userEmailAddress} isWallet={true} userId={userId} />
				</Form>
			</Modal.Content>
			<Modal.Actions>
				<Button onClick={onClose}>Cancel</Button>
				<Button primary onClick={onAddButtonClick} disabled={!isValid}>
					Add
				</Button>
			</Modal.Actions>
		</Modal>
	);
};

AddWalletModal.propTypes = {
	userEmailAddress: PropTypes.string.isRequired
};

export default AddWalletModal;
